import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { App } from './app/App';
import './index.css';
import './select-styles.css';
import './timeline-range.css';
import './react-toggle.css';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { AppProvider } from 'lib/context/app';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // query options
      retry: 0,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    },
    mutations: {
      // mutation options
      retry: 0,
    },
  },
});

const appElement = (
  <QueryClientProvider client={queryClient}>
    <AppProvider>
      <App />
    </AppProvider>
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
);

ReactDOM.render(appElement, document.getElementById('root'));
